import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulk-application',
  templateUrl: './bulk-application.component.html',
  styleUrls: ['./bulk-application.component.scss']
})
export class BulkApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
